import { DocumentNode } from 'graphql';
import { ApolloQueryResult } from 'apollo-client';
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class SelectOptionsFetcher extends Vue {
  async getClientOptions(query: DocumentNode, variables = {}) {
    const result = await this.$apollo.query({
      query,
      variables,
    });
    return this.flatGraphqlResult(result);
  }

  flatGraphqlResult(result: ApolloQueryResult<any>) {
    const entries = Object
      .entries(result.data as Record<string, any>)
      .filter(([key]) => key !== '__typename')
      .map(([key, value]) => [key, this.performEdges(value.edges)]);
    return Object.fromEntries(entries);
  }

  performEdges(edges: Record<string, any>[]) {
    return edges.flatMap((edge) => edge.node);
  }
}
